import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Segmentacao } from '../models/segmentacao';

@Injectable({
  providedIn: 'root'
})
export class SegmentacaoService {

  constructor(private http: HttpClient) {

  }

  consultar() {
    return this.http.get<Segmentacao[]>(globals.apiUrl + '/api/Segmentacao/Lista');
  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);
    return this.http.get<any>(globals.apiUrl + '/api/Segmentacao/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<Segmentacao>(globals.apiUrl + '/api/Segmentacao/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  consultarMostrarKitPronto() {
    return this.http.get<any>(globals.apiUrl + '/api/Segmentacao/MostrarKitPronto');
  }

  salvar(seg: Segmentacao) {
    return this.http.post(globals.apiUrl + '/api/Segmentacao/Salvar', seg);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Segmentacao/Excluir',
      { params: new HttpParams().set('id', id) });
  }

}
